var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.27169C14 11.2877 7.00138 20 7.00138 20C7.00138 20 0 11.2877 0 7.27169C0 3.25425 3.13342 0 7.00138 0C10.8679 0 14 3.25425 14 7.27169Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62604 7.27128C9.62604 8.77907 8.44998 9.99959 7.00156 9.99959C5.54901 9.99959 4.37708 8.77907 4.37708 7.27128C4.37708 5.76635 5.54901 4.54297 7.00156 4.54297C8.44998 4.54297 9.62604 5.76635 9.62604 7.27128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.185436c1fa01eac4ba0e8840e42cf5f6.svg";
export { ForwardRef as ReactComponent };